import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

const reportReview = async (reviewId, setError, refreshReviews, logoutHandler) => {
  await apiCaller
    .put(`${URLS.WORKSHOP_REVIEWS}${reviewId}/${URLS.WORKSHOP_REVIEWS_REPORT}`)
    .then(() => {
      setError(null);
      refreshReviews();
    })
    .catch((e) => {
      if (e.message === STRINGS.settings.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.settings.error400Template) {
        setError(STRINGS.settings.error400Text);
      }
    });
};

export default reportReview;
